import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  CanActivateChild,
  RouterStateSnapshot,
  UrlTree
} from '@angular/router';
import { Observable } from 'rxjs';
import { StateService } from '../services/storage/state.service';
import { LocalStorageVariables } from '../enum/localstorage-variables';
import { isPlatformBrowser } from '@angular/common';
import { LocalStorageService } from '../services/storage/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class RedirectGuard implements CanActivate, CanActivateChild {
  private state = inject(StateService);
  private localStorage = inject(LocalStorageService);
  platformId = inject(PLATFORM_ID);
  constructor() {
  }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    this.state.getLoginStatus().subscribe((res) => {
      if (!res) {
        if (!state.url.includes('authenticate/login')) {
          if (
            typeof window !== 'undefined' &&
            isPlatformBrowser(this.platformId)
          ) {
            this.localStorage.setItem(
              LocalStorageVariables.redirect_url,
              state.url
            );
          }
        }
      }
    });
    return true;
  }
  canActivateChild(
    childRoute: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    this.state.getLoginStatus().subscribe((res) => {
      if (!res) {
        if (!state.url.includes('authenticate/login')) {
          if (
            typeof window !== 'undefined' &&
            isPlatformBrowser(this.platformId)
          ) {
            this.localStorage.setItem(
              LocalStorageVariables.redirect_url,
              state.url
            );
          }
        }
      }
    });
    return true;
  }
}
